import { render, staticRenderFns } from "./deliver-sumary.vue?vue&type=template&id=53e4471a&scoped=true"
import script from "./deliver-sumary.vue?vue&type=script&lang=js"
export * from "./deliver-sumary.vue?vue&type=script&lang=js"
import style0 from "./deliver-sumary.vue?vue&type=style&index=0&id=53e4471a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e4471a",
  null
  
)

export default component.exports